import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"

export type ManageItemBadgeProps = ComponentProps<"span">

function ManageItemBadge(props: ManageItemBadgeProps) {
  const { children = "Member", className, ...spanProps } = props
  return (
    <span className={cn("manage-item-badge", className)} {...spanProps}>
      <Icon src="check" />
      {children}
    </span>
  )
}

export default ManageItemBadge
